import axios from 'axios';
import iView from '@/components';
import api from './api-config';
//import "@/styles/index.less";

// 访问进度条
import NProgress from './http-nprogress';
NProgress.configure({ showSpinner: false });

const $Toast = iView.Toast;

/**
 * Global HTTP Setting
 */
axios.defaults.timeout = 60000;
//axios.defaults.baseURL = 'http://115.28.43.187:8080';
axios.defaults.baseURL = 'https://beastush.sweetrouble.com';
axios.defaults.withCredentials = true; // 携带cookie
//axios.defaults.crossDomain = true; //跨域

axios.defaults.transformRequest = [function (data) {
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
}];

/*
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
axios.defaults.headers.common['Access-Control-Max-Age'] = 1000;

axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'POST, GET, DELETE, PUT, PATCH, OPTIONS';
*/
//
//axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'POST, GET, DELETE, PUT, PATCH, OPTIONS';
//axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
//axios.defaults.headers.common['Content-type'] = 'application/json';
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
// http Request instance
const httpInstance = axios.create();
// Merge axios to httpInstance, 
Object.setPrototypeOf(httpInstance, axios);

// Add a request interceptor
httpInstance.interceptors.request.use(config => {
    NProgress.start();

    const defaultData = {
        //accesstoken: state.accessToken
        //accesstoken: '12345'
    };

    //console.log(axios.defaults)

    if( config.method === 'post' ) {
        config.data = Object.assign(defaultData, config.data);
    }

    if( config.method === 'get' ) {
        config.params = Object.assign(defaultData, config.params);
    }


    //console.log(config)
    return config;

    }, e => {

    NProgress.done();
    $Toast.error('请求失败, 请稍后再试!');
    return Promise.reject(e);
});

// Add a response interceptor
httpInstance.interceptors.response.use(res => {
    NProgress.done();
    return res;
}, e => {
    
    const statusCode = e.response.status;
    //console.log(statusCode)
    
    if (statusCode === 404) {
        $Toast.error('接口已被关闭!');
    } else {
        $Toast.error('请求超时或服务器出错!');
    }
    NProgress.done();
    return Promise.reject(e);
    /*
    const statusCode = e.response.status;
    console.log(statusCode)
    return res;*/
});

export default httpInstance;